













import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    intervals: {
      type: Array,
      default: () => []
    },
    amountOfElementsToDisplay: {
      type: Number,
      default: 0
    }
  }
})
export default class TimelineBar extends Vue {
  trackLength: number = 0
  thumbOffsetLeft: number = 0
  currentInterval: number = 0
  moveAccumulator: number = 0
  previousTouch: any = null

  get intervalWidth () {
    return this.trackLength / this.amountOfElemsToDisplay
  }

  get amountOfElemsToDisplay () {
    return this.$props.intervals.length - this.$props.amountOfElementsToDisplay
  }

  mounted () {
    this.setTrackWidth()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('mouseup', this.onMouseUp)
  }

  destroyed () {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('mouseup', this.onMouseUp)
    window.removeEventListener('touchstart', this.onTouchStart)
    window.removeEventListener('touchmove', this.onTouchMove)
  }

  onScroll (e: any) {
    this.accumulateAndMoveThumb(e.wheelDelta)
  }

  onResize () {
    this.setTrackWidth()
    this.goToPosition(0, 0)
  }

  onTouch () {
    window.addEventListener('touchstart', this.onTouchStart)
    window.addEventListener('touchmove', this.onTouchMove)
  }

  onTouchStart (e: any) {
    this.previousTouch = e.touches[0]
  }

  onTouchMove (e: any) {
    const currentTouch = e.touches[0]
    const movement = currentTouch.pageX - this.previousTouch.pageX
    this.accumulateAndMoveThumb(movement)
    this.previousTouch = currentTouch
  }

  onTouchEnd () {
    window.removeEventListener('touchstart', this.onTouchStart)
    window.removeEventListener('touchmove', this.onTouchMove)
  }

  onClick (e: PointerEvent) {
    const offsetInElem = e.offsetX
    const interval = Math.round(offsetInElem / this.trackLength * this.amountOfElemsToDisplay)
    this.goToPosition(interval * this.intervalWidth, interval)
  }

  onMoseDown () {
    window.addEventListener('mousemove', this.accumulateMouseMove)
  }

  onMouseUp () {
    window.removeEventListener('mousemove', this.accumulateMouseMove)
  }

  accumulateMouseMove (e: MouseEvent) {
    this.accumulateAndMoveThumb(e.movementX)
  }

  accumulateAndMoveThumb (offset: number) {
    this.moveAccumulator += offset
    if (Math.abs(this.moveAccumulator) >= this.intervalWidth) {
      this.moveThumb(this.moveAccumulator > 0 ? this.intervalWidth : -this.intervalWidth)
      this.moveAccumulator = 0
    }
  }

  moveThumb (offset: number) {
    // added +- 1 pixel to compensate for decimal length values
    if (this.thumbOffsetLeft + offset <= (this.trackLength + 1) && this.thumbOffsetLeft + offset >= -1) {
      this.goToPosition(this.thumbOffsetLeft + offset, this.currentInterval + (offset >= 0 ? 1 : -1))
    }
  }

  goToPosition (offset: number, interval: number) {
    this.thumbOffsetLeft = offset
    this.currentInterval = interval
    this.$emit('moveToInterval', this.currentInterval)
  }

  setTrackWidth () {
    this.$nextTick(() => {
      // this.trackLength = document.body.querySelector('#timeline').offsetWidth
      this.trackLength = (this.$refs.timeline as HTMLElement).offsetWidth
    })
  }
}
